import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";


const __default__ = {
  name: "ClipartWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {}
  },
  setup(__props: any) {

const props = __props;

// Function to convert hex to rgba
function hexToRgba(hex: string, alpha: number) {
  let c = hex.replace("#", "");
  if (c.length === 3)
    c = c
      .split("")
      .map((x) => x + x)
      .join("");
  const num = parseInt(c, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
}

// Computed property to determine background style
const backgroundStyle = computed(() => {
  // If there's a bgConfig with gradient, apply gradient
  if (props.config.bgConfig?.gradient) {
    const gradient = props.config.bgConfig.gradient;
    const start = hexToRgba(gradient.startColor, gradient.startColorOpacity);
    const end = hexToRgba(gradient.endColor, gradient.endColorOpacity);

    // Determine gradient direction
    let linearDirection = "to right";
    let radialPosition = gradient.direction || "center";

    switch (gradient.direction) {
      case "left-right":
        linearDirection = "to right";
        break;
      case "right-left":
        linearDirection = "to left";
        break;
      case "top-bottom":
        linearDirection = "to bottom";
        break;
      case "bottom-top":
        linearDirection = "to top";
        break;
      case "top-left-bottom-right":
        linearDirection = "135deg";
        break;
      case "top-right-bottom-left":
        linearDirection = "225deg";
        break;
      case "bottom-left-top-right":
        linearDirection = "45deg";
        break;
      case "bottom-right-top-left":
        linearDirection = "315deg";
        break;
      default:
        linearDirection = "to right";
    }

    if (gradient.type === "linear") {
      return `linear-gradient(${linearDirection}, ${start}, ${end})`;
    } else {
      // radial
      return `radial-gradient(circle at ${radialPosition}, ${start}, ${end})`;
    }
  }

  // If there's a bgConfig with fillColor, use that
  if (props.config.bgConfig?.fillColor) {
    return props.config.bgConfig.fillColor;
  }

  // Fallback to the original fillColor
  return props.config.fillColor || "#000";
});

return (_ctx: any,_cache: any) => {
  return (
      _ctx.config.name == 1 ||
      _ctx.config.name == 3 ||
      _ctx.config.name == 4 ||
      _ctx.config.name == 'Rectangle' ||
      _ctx.config.name == 'Square'
    )
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({
      width: '100%',
      height: '100%',
      background: backgroundStyle.value,
      border:
        (_ctx.config.strokeWidth || 1) +
        'px solid ' +
        (_ctx.config.outlineColor || '#000'),
      borderRadius: _ctx.config.name == 3 || _ctx.config.name == 'Square' ? '0' : '0',
    })
      }, null, 4))
    : (_ctx.config.name == 2 || _ctx.config.name == 'Circle')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({
      width: '100%',
      height: '100%',
      background: backgroundStyle.value,
      border:
        (_ctx.config.strokeWidth || 1) +
        'px solid ' +
        (_ctx.config.outlineColor || '#000'),
      borderRadius: '50%',
    })
        }, null, 4))
      : (_ctx.config.name == 4 || _ctx.config.name == 'Triangle')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle({
      borderBottom: '100px solid ' + (_ctx.config.fillColor || '#000'),
      borderLeft: '50px solid transparent',
      borderRight: '50px solid transparent',
      borderTop: '0 solid transparent',
      borderWidth: '0 50px 100px 50px',
      borderStyle: 'solid',
      width: '0',
      height: '0',
      position: 'absolute',
      left: 'calc(50% - 50px)',
      top: 'calc(50% - 50px)',
    })
          }, null, 4))
        : _createCommentVNode("", true)
}
}

})